module.exports = __webpack_public_path__ + "img/blt-search01.6b82efe1.svg";